import moment from 'moment';

export function fmtPrice(price) {
  return parseFloat(price || 0).toFixed(2);
}

export function fmtPercent(percentage) {
  return parseFloat(percentage || 0).toFixed(2);
}

export function fmtDate(dt) {
  return moment(dt).format('D.M.YYYY');
}

export function fmtTime(dt) {
  return moment(dt).format('HH:mm');
}

export function fmtTimeHrs(dt) {
  return moment(dt).format('HH');
}

export function fmtTimeMins(dt) {
  return moment(dt).format('mm');
}

export function fmtDatetime(dt) {
  return moment(dt).format('D.M.YYYY \u2013 HH:mm');
}

export function isValidDT(dt) {
  return moment(dt).isValid();
}


// WEBPACK FOOTER //
// ./src/model/formatters.js